<template>
    <table class="table table-bordered table-hover table-grid">
        <thead class="thead-dark">
        <tr>
            <th>#</th>
            <th v-for="(column, colKey) in gridColumns"
                :key="colKey"
                scope="col"
                style="min-width: 4em"
                @click="showHelp(colKey)"
            >
                {{ column }}
            </th>
        </tr>
        </thead>
        <tbody>
        <data-grid-row v-for="(gridItem, index) in gridItems" :key="gridItem.local_versions__id.original"
                       :id="gridItem.local_versions__id.original"
                       :brand-id="brandId"
                       :country-id="countryId"
                       :route="route"
                       :is-locked="isLocked"
                       :ref="gridItem.local_versions__id.original"
                       :is-first-row-of-new-category="isFirstRowOfCategory(index)"
                       @dataUpdated="onDataUpdated"
                       :grid-item-index="index">
        </data-grid-row>
        </tbody>
    </table>
</template>
<script>

export default {
    props: {
        gridColumns: {
            type: Array|Object,
            required: true
        },
        gridItems: {
            type: Array|Object,
            required: true
        },
        brandId: {
            type: Number|String,
            required: true
        },
        countryId: {
            type: String,
            required: true
        },
        route: {
            type: String,
            required: true
        },
        isLocked: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            isRowUpdated: false,
        }
    },

    beforeMount () {
        this.setGridItems();
    },

    mounted () {
        this.setDates();
        this.setCategories();
    },

    methods: {
        showHelp: function (topic) {
            this.$root.$emit('bv::show::modal', 'modal-help');
            this.$root.$data.HELP_TOPIC = this.translateHelpKeys(topic);
        },
        // Translate the keys where they differ from PriceStory's
        translateHelpKeys: function (colKey) {
            let translations = {
                local_versions__id: 'id',
                versions__id: 'version_id',
                models__name: 'model_name',
                local_versions__name: 'version_name',
                local_specs__brakes_abs_avail: 'abs_avail',
                local_specs__brakes_abs_price: 'abs_price',
            }

            if (translations[colKey]) {
                return translations[colKey];
            }

            return colKey.split('__')[1];
        },
        isFirstRowOfCategory: function (index) {
            if (index < 1) {
                return false;
            }
            let currCategory = this.gridItems[index]['local_versions__catalog_category']['original'];
            let currCategoryUpdated = this.gridItems[index]['local_versions__catalog_category']['updated'];
            let prevCategory = this.gridItems[index-1]['local_versions__catalog_category']['original'];
            let prevCategoryUpdated = this.gridItems[index-1]['local_versions__catalog_category']['updated'];
            if (currCategoryUpdated) (currCategory = currCategoryUpdated);
            if (prevCategoryUpdated) (prevCategory = prevCategoryUpdated);
            return currCategory !== prevCategory;
        },
        onDataUpdated: function () {
            this.$nextTick(() => {
                this.setDates();
            });
        },
        setGridItems: function () {
            this.$store.commit('setGridItems', this.gridItems);
        },
        setDates: function () {
            let dates = [];

            for (var refName in this.$refs) {
                dates.push(this.$refs[refName][0].$refs['prices__data_date__' + refName][0].value);
            }

            this.$store.commit('setDates', dates);
        },
        setCategories: function () {
            let categories = [];

            for (var refName in this.$refs) {
                categories.push(this.$refs[refName][0].$refs['local_versions__catalog_category__' + refName][0].value);
            }

            this.$store.commit('setCategories', categories);
        }
    },
}
</script>
